import { useEffect, useState } from "react";


export function useDocument(): Document | null {
    const [theDocument, setTheDocument] = useState<Document | null>(null);

    useEffect(() => {
        setTheDocument(document);
    }, []);

    return theDocument;
}


export function useWindow(): Window | null {
    const [theWindow, setTheWindow] = useState<Window | null>(null);

    useEffect(() => {
        setTheWindow(window);
    }, []);

    return theWindow;
}
